import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FeedbackData, RestService } from 'cargo-chief-commons';
import { UtilService } from '../util/util.service';
import { UrlService } from '../url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { SegmentWrapperService } from '../segmentWrapper/segment-wrapper.service';
import { PricingFeedbackDialogComponent } from '@shared/pricing-feedback-dialog/pricing-feedback-dialog.component';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';

@Injectable({
	providedIn: 'root',
})
export class PricingFeedbackService {
	NO_OF_SEARCHES_WITHOUT_FEEDBACK = 'noOfSearchesWithoutFeedback';
	SEARCH_LIMIT_WITHOUT_FEEDBACK = 10;
	FEEDBACK_TYPE = {
		SPOT_ON: 'spot_on',
		INACCURATE: 'inaccurate',
	};

	constructor(
		public dialog: MatDialog,
		private utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService,
		private segmentWrapper: SegmentWrapperService
	) {}

	submitLanePriceReview(lanePriceSearchId: string, feedbackData: FeedbackData) {
		if (
			!this.utilService.isNullOrUndefined(feedbackData.currentRate) &&
			feedbackData.currentRate > 0
		) {
			feedbackData.currentRate = feedbackData.currentRate * 100;
		} else {
			feedbackData.currentRate = null;
		}
		const url = this.urlService.addPriceReview();
		const payload = {
			...feedbackData,
			lanePriceSearchId,
		};
		this.restService.POST(url, payload).subscribe(
			() => {},
			() => {}
		);
	}

	showFeedbackSuccessSnackbar() {
		this.utilService.showSnackbar('Thank you for your feedback', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
	}

	firePricingSegmentEvent(
		event: string,
		dataKey: string,
		result: any,
		rateFeedback = null,
		truckSearchId: string,
		truckLaneSearchId: string,
		searchTruckForm: any,
		feedback_type: string = null,
		recentTransactionsCount: number = null
	) {
		let payload = {
			user: this.utilService.getUserDataForSegmentEvent(),
			truckSearchId: truckSearchId,
			truckLaneSearchId: truckLaneSearchId,
			search: searchTruckForm,
			[dataKey]: result,
			rateFeedback,
		};
		if (!this.utilService.isNullOrUndefined(feedback_type)) {
			payload['feedback_type'] = feedback_type;
		}
		if (!this.utilService.isNullOrUndefined(recentTransactionsCount)) {
			payload['recentTransactionsCount'] = recentTransactionsCount;
		}
		this.segmentWrapper.fireSegmentEvent(event, payload);
	}

	openPricingFeedbackDialog(
		{ openedManually, rateType } = { openedManually: true, rateType: null }
	): Promise<{ feedbackData: FeedbackData | null; feedbackType: 'spotOn' | 'notAccurate' }> {
		const dialogRef = this.dialog.open(PricingFeedbackDialogComponent, {
			width: '600px',
			disableClose: true,
			data: {
				openedManually,
				rateType,
			},
		});
		return dialogRef.afterClosed().toPromise();
	}

	setNoOfSearchesWithoutFeedbackCounter(count: number) {
		localStorage.setItem(this.NO_OF_SEARCHES_WITHOUT_FEEDBACK, count.toString());
	}

	incrementNoOfSearchesWithoutFeedbackCounter(): void {
		let count = localStorage.getItem(this.NO_OF_SEARCHES_WITHOUT_FEEDBACK);
		this.setNoOfSearchesWithoutFeedbackCounter(Number(count) + 1);
	}

	searchLimitExceeded(): boolean {
		let count = localStorage.getItem(this.NO_OF_SEARCHES_WITHOUT_FEEDBACK);
		return Number(count) >= this.SEARCH_LIMIT_WITHOUT_FEEDBACK;
	}

	async showFeedbackModal({
		lanePricing,
		searchTruckForm,
		truckSearchIds,
		truckLaneSearchId,
	}: {
		lanePricing: any;
		searchTruckForm: any;
		truckSearchIds?: any;
		truckLaneSearchId?: any;
	}) {
		const { feedbackData, feedbackType } = await this.openPricingFeedbackDialog({
			openedManually: false,
			rateType: null,
		});
		switch (feedbackType) {
			case 'spotOn':
				const spotOnFeedbackData = {
					rateType: 'spotOn',
					hasRate: true,
					currentRate: Math.round(lanePricing.allInCost),
				};
				this.firePricingSegmentEvent(
					SegmentEventsConstants.user_submitted_rate_feedback,
					'lanePricing',
					lanePricing,
					spotOnFeedbackData,
					truckSearchIds,
					truckLaneSearchId,
					searchTruckForm,
					this.FEEDBACK_TYPE.SPOT_ON
				);
				this.submitLanePriceReview(lanePricing['lanePriceSearchId'], spotOnFeedbackData);
				this.showFeedbackSuccessSnackbar();
				break;
			case 'notAccurate':
				if (!this.utilService.isNullOrUndefined(feedbackData)) {
					this.firePricingSegmentEvent(
						SegmentEventsConstants.user_submitted_rate_feedback,
						'lanePricing',
						lanePricing,
						feedbackData,
						truckSearchIds,
						truckLaneSearchId,
						searchTruckForm,
						this.FEEDBACK_TYPE.INACCURATE
					);
					this.submitLanePriceReview(lanePricing['lanePriceSearchId'], feedbackData);
					this.showFeedbackSuccessSnackbar();
				}
				break;
		}
	}
}
